(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authorized-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-scroll-hero')) {
  customElements.define('aw-scroll-hero', class extends HTMLElement {
    connectedCallback() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateProgress();
        });
      };
      this.configure = () => {
        this.toggleAttribute('data-active', !this.motionQuery.matches);
        this.schedule();
      };
      document.addEventListener('scroll', this.schedule, {passive:true,capture:true});
      window.addEventListener('resize', this.schedule, {passive:true});
      this.motionQuery.addEventListener('change', this.configure);
      this.configure();
    }
    updateProgress() {
      if (this.motionQuery.matches) { this.style.removeProperty('--aw-progress'); return; }
      const rect = this.getBoundingClientRect();
      const desktop = innerWidth > 900;
      const distance = desktop ? Math.max(1, rect.height - innerHeight) : Math.max(1, rect.height * .65);
      const progress = Math.max(0, Math.min(1, (desktop ? -rect.top : innerHeight * .15 - rect.top) / distance));
      this.style.setProperty('--aw-progress', progress.toFixed(4));
    }
    disconnectedCallback() {
      document.removeEventListener('scroll', this.schedule, true);
      window.removeEventListener('resize', this.schedule);
      this.motionQuery?.removeEventListener('change', this.configure);
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
